var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "best_buys_tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "超值选购列表", name: "table" } },
            [
              _c("best-buys-table-pane", {
                ref: "bestBuysTable",
                on: {
                  addActivity: _vm.handleAddActivity,
                  editActivity: _vm.handleEditActivity,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeName === "config"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "超值选购配置", name: "config" } },
                [
                  _c("best-buys-config-pane", {
                    ref: "bestBuysConfig",
                    attrs: { "best-buys-fn-id": _vm.bestBuysFnId },
                    on: { success: _vm.handleSuccess },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }